import React, {useState, useEffect, useCallback} from 'react';
import {lstorage} from 'utils/lstorage.js';
import ExhibitViewer from "components/exhibit/ExhibitViewer.js";
import {isMobile} from 'react-device-detect';
import ExploreWork from './details/ExploreWork.js';
import {
    setWallpaper,
    setExploreWork,
    setAnimateWallpaper
} from 'actions/index.js';
import ipfs from 'decentralized/Ipfs.js';
import CommentsPane from './comments/CommentsPane.js';
import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js"
import {useLists} from './useLists.js';
import {setExploreUnpublished} from 'actions/index.js';
import ListsView from './lists/ListsView.js';
import ExploreToolbar from './toolbar/ExploreToolbar.js';
import AnnotationsView from './links/AnnotationsView.js';
import ExploreSearch from  './ExploreSearch.js';
import ExploreGuilds from './guilds/ExploreGuilds.js';
import {HOME, GUILDS, MESSAGES} from 'constants/explore-options.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {loadSample, deleteSample} from './loading.js';
import {loadWork, unloadWork} from 'engine/mix/actions.js';
import {initSequencerEngine} from './initSequencer.js';
import Sample from 'repos/Sample.js';
import {
    setExploreAllSequences,
    setCommandDown,
    setWorksLoaded
} from 'actions/index.js';
import { connect } from "react-redux";
import ethereum from 'decentralized/ethereum.js';
import Navigation from './Navigation.js';
import People from './people/People.js';
import {fetchWorks} from './work/fetchWorks.js';
import Mixer from './mix2/Mixer.js';
import Works from './work/Works.js';
import "../../Explore2.scss";

const ExplorePage2 = (props) => {
    const [sequencerEngine, setSequencerEngine] = useState(undefined);
    let {personSelected, worksLoaded, setWorksLoaded, guildId} = props;
    const [userId, setUserId] = useState(undefined);
    const [samplersLoaded, setSamplersLoaded] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTag, setSearchTag] = useState(undefined);
    const [searchOptions, setSearchOptions] = useState(["Starred", "Projects"]);
    const {
        lists, onListChanged, onClickList, creatingNewList, setCreatingNewList} =
          useLists(props, sequencerEngine);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        let engine = initSequencerEngine(props.store);
        window.explore = true;
        setSequencerEngine(engine);
        fetchUserId();
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
    }, []);

    useEffect(() => {
        props.setAllSequences([]);
        setIsFetching(true);
        fetchWorks(props.setAllSequences, setIsFetching, searchOptions, searchTerm, searchTag, guildId, personSelected)
            .then(x => setIsFetching(false));
    }, [personSelected, searchOptions, setIsFetching, searchTerm, searchTag, guildId]);

    useEffect(() => {
        if (!sequencerEngine) {
            return;
        }
        let sequenceId = props.match && props.match.params.sequenceId != undefined ? 
            props.match.params.sequenceId :
        null;
        if (sequenceId) {
            ethereum.getSequence(sequenceId).then(
                work => {
                    if (!work) {
                        work = {newSequence: sequenceId, title: "Unpublished work"};
                    }
                    sequencerEngine.dispatch(
                        loadWork(work));
                    props.setExploreWork(work);
                });
        }
    }, [sequencerEngine]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Meta') {
            props.setCommandDown(true);
        }
    }, []);

    const onKeyUp = useCallback((e) => {
        if (e.key === 'Meta') {
            props.setCommandDown(false);
        }
    }, []);

    const _unloadWork = useCallback((work) => {
        sequencerEngine.dispatch(
            unloadWork(work));
    }, [sequencerEngine]);

    const _loadWork= useCallback((work) => {
        sequencerEngine.dispatch(
            loadWork(work));
    }, [sequencerEngine]);

    const loadMix = useCallback((mix) => {
        sequencerEngine.loadMix(mix);
    }, [sequencerEngine]);

    const _loadSample = 
        loadSample(sequencerEngine, setSamplersLoaded);

    const _deleteSample = deleteSample(
        setSamplersLoaded, samplersLoaded, sequencerEngine);

    const fetchUserId = async () => {
        let userId = await ethereum.getUser();
        setUserId(userId);
    };

    useEffect(() => {
        if (isMobile && worksLoaded && worksLoaded.length > 0) {
            props.setExploreWork(worksLoaded[0]);
        }
    }, [worksLoaded]);

    let exploreClass = "explore-2";
    let style = {};
    if (props.wallpaper) {
        style.backgroundImage = 'url(' + ipfs.getHashUrl(props.wallpaper) + ')';
    } else {
        exploreClass += " no-wallpaper";
    }
    if (props.animateWallpaper) {
        exploreClass += " animate";
    }

    useEffect(() => {
        let item = lstorage.getItem("wallpaper");
        if (item) {
            props.setWallpaper(item);
        } else {
            props.setWallpaper('QmUh2FeN3bw2VdcRVksDctr1ihjDwHpNhE6o9mkBhF2huB');
        }
        item  = lstorage.getItem("animateWallpaper");
        if (item !== undefined) {
            props.setAnimateWallpaper(item === "true");
        }
    }, []);

    if (worksLoaded && worksLoaded.length > 0) {
        exploreClass += " work-loaded";
    }
    if (props.exploreWork) {
        exploreClass += " exploring";
    }
    return (
        <div className={exploreClass} style={style}>
          {/*<ExhibitViewer sequencerEngine={props.exploreWork && sequencerEngine && sequencerEngine.getHead()}/>*/}
         <ConditionedComponent condition={props.exploreOption === GUILDS}>
            <ExploreGuilds store={props.store}/>
          </ConditionedComponent>
          <ConditionedComponent condition={props.exploreOption === HOME}>
            <AnnotationsView
              annotationsView={props.annotationsView}/>
            <Mixer
              unloadWork={_unloadWork}
              sequencerEngine={sequencerEngine}
              samplersLoaded={samplersLoaded}
              lists={
                  <ListsView
                    loadWork={_loadWork}
                    removeList={onClickList}
                    onListChanged={onListChanged}
                    creatingNewList={creatingNewList}
                    hide={() => setCreatingNewList(false)}
                    lists={lists}/>}
              deleteSample={_deleteSample}
              worksLoaded={worksLoaded}>
              {sequencerEngine ? 
               <div className="login-and-comments">
                 <Navigation
                   store={sequencerEngine.store}
                   setSearchOptions={setSearchOptions}
                   searchOptions={searchOptions}
                   setSearchTerm={setSearchTerm}
                   searchTerm={searchTerm}/> 
                 <CommentsPane sequencerEngine={sequencerEngine}/>
               </div>
               : ''}
            </Mixer>
           <ExploreToolbar
              onNewList={() => setCreatingNewList(true)}>
              <ExploreSearch
                searchTag={searchTag}
                setSearchTag={setSearchTag}
                setSearchOptions={setSearchOptions}
                searchOptions={searchOptions}
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}/>
            </ExploreToolbar>
            {isFetching ? <UnknownProgressBar className="world-fetcher" text="Fetching the world"/> : ''}
            {props.exploreWork ?
             <ExploreWork work={props.exploreWork} sequencerEngine={sequencerEngine}/>
             :
            <Works
              onClickMix={loadMix}
              onClickList={onClickList}
              loadSample={_loadSample}
              onClickWork={_loadWork}
              setSearchTag={setSearchTag}
              searchOptions={searchOptions}
              searchTerm={searchTerm}/>}
            <div color="radial-gradient(75.29% 75.29% at 64.96% 24.36%, #F0DFA7 0.52%, #FDBDAA 18.75%, #FEA186 34.38%, #F09277 49.48%, #D27584 74.48%, #6B7B8A 100%)" className="coke-machine-glow"></div>
          </ConditionedComponent>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        setAllSequences : sequences => dispatch(setExploreAllSequences(sequences)),
        setCommandDown: x => dispatch(setCommandDown(x)),
        setWorksLoaded: x => dispatch(setWorksLoaded(x)),
        setExploreUnpublished: (x) => dispatch(setExploreUnpublished(x)),
        setWallpaper: w => dispatch(setWallpaper(w)),
        setAnimateWallpaper: w => dispatch(setAnimateWallpaper(w)),
        setExploreWork: w => dispatch(setExploreWork(w)),
    };
};

const mapStateToProps = (state, props) => {
    return {
        allSequences: state.explore.allSequences,
        personSelected: state.explore.personSelected,
        worksLoaded: state.explore.worksLoaded,
        exploreOption: state.explore.exploreOption,
        annotationsView: state.explore.annotationsView,
        wallpaper: state.sequencer.wallpaper,
        animateWallpaper: state.sequencer.animateWallpaper,
        exploreWork: state.explore.exploreWork,
        personSelected: state.explore.personSelected,
        guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ExplorePage2);


